<template>
    <div class="ellipsis-container" :class="{ 'nonellipsis': !isEllipsis }">
        <template v-if="isEllipsis">
            <div class="ellipsis-shadow">
                <textarea :rows="rows" readonly></textarea>
                <div class="ellipsis-shadow-box" ref="refBox">{{ showContent }}... <span class="ellipsis-btn">{{ langMap['展开'] }}</span><div style="display: inline-block;" ref="refTail"></div></div>
            </div>
            <div class="ellipsis-real-box">{{ showContent }}<template v-if="textLength < content.length">... <span
                    class="ellipsis-btn"
                    @click="onExpand"
                >{{ langMap['展开'] }}</span></template>
            </div>
        </template>
        <template v-else>{{ content }} <span
                class="ellipsis-btn"
                @click="onUnExpand"
            >{{ langMap['收起'] }}</span>
        </template>
    </div>
</template>

<script>
import i18n from './i18n.js';
import resizeObserver from 'element-resize-detector';
const observer = resizeObserver({strategy: "scroll"});

export default {
    name: 'Ellipsis',
    props: {
        content: {
            type: String,
            default: ''
        },
        rows: {
            type: Number,
            default: 3
        },
        language: String
    },
    data() {
        return {
            isEllipsis: true,
            textLength: 0,
            beforeRefresh: false,
            boxWidth: 0,
            boxHeight: 0
        }
    },
    computed: {
        langMap() {
            return i18n.messages[this.language];
        },
        showContent() {
            return this.content.substr(0, this.textLength);
        }
    },
    mounted() {
        observer.listenTo(this.$refs.refBox, el => {
            if (el.offsetWidth == this.boxWidth && el.offsetHeight == this.boxHeight) return;
            this.boxWidth = el.offsetWidth;
            this.boxHeight = el.offsetHeight;
            this.refresh();
        })
    },
    beforeDestroy() {
        observer.uninstall(this.$refs.refBox);
    },
    methods: {
        refresh() {
            let stopLoop = false;
            if (this.beforeRefresh) {
                stopLoop = true;
            }
            this.beforeRefresh = true;
            this.textLength = this.content.length;

            const checkLoop = (start, end) => {
                if (stopLoop || start + 1 >= end) {
                    this.beforeRefresh = false;
                    return;
                }
                const boxRect = this.$refs.refBox.getBoundingClientRect();
                const tailRect = this.$refs.refTail.getBoundingClientRect();
                const overflow = this.content.length > 20 && tailRect.bottom > boxRect.bottom;
                overflow ? (end = this.textLength) : (start = this.textLength);
                this.textLength = Math.floor((start + end) / 2);
                this.$nextTick(() => checkLoop(start, end));
            }
            this.$nextTick(() => checkLoop(0, this.textLength))
        },
        onExpand() {
            this.isEllipsis = false;
        },
        onUnExpand() {
            this.isEllipsis = true;
        }
    }
}
</script>

<style lang="less" scoped>
.ellipsis-container {
    position: relative;

    &.nonellipsis {
        white-space: pre-wrap;
    }

    .ellipsis-shadow {
        width: 100%;
        position: absolute;
        display: flex;
        pointer-events: none;
        user-select: none;
        opacity: 0;
        filter: alpha(opacity=0);

        textarea {
            flex: auto;
            padding: 0;
            font-size: inherit;
            line-height: inherit;
            resize: none;
            border: none;
            outline: none;
            overflow: hidden;
        }

        .ellipsis-shadow-box {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
        }
    }

    .ellipsis-btn {
        color: var(--disabled-color);
        cursor: pointer;
    }
}
</style>